const state = {
	mySelectedStatuses: []
};

const getters = {
	getMySelectedStatuses(state) {
		return state.mySelectedStatuses
	}
};

const actions = {
	changeMySelectedStatuses({ commit, state }, payload) {
		if (state.mySelectedStatuses.includes(payload)) {
			commit('removeMyStatus', state.mySelectedStatuses.indexOf(payload))
		} else {
			commit('addMyStatus', payload);
		}
	},
	syncMyFiltersStore({commit}) {
		let selectedStatuses = localStorage.getItem('mySelectedStatuses');
		if (selectedStatuses) {
			commit('addMyMultipleStatuses', selectedStatuses);
		}
	}
};

const mutations = {
	addMyStatus(state, payload) {
		state.mySelectedStatuses.push(payload);
		localStorage.setItem('mySelectedStatuses', state.mySelectedStatuses)
	},
	addMyMultipleStatuses(state, payload) {
		let arr = payload.split(',').map(function (x) {
			return parseInt(x);
		});

		state.mySelectedStatuses.push(...arr);
	},
	removeMyStatus(state, payload) {
		state.mySelectedStatuses.splice(payload, 1)
		localStorage.setItem('mySelectedStatuses', state.mySelectedStatuses)
	}
};
export default { state, getters, actions, mutations };
